import Cookies from 'js-cookie';

export const cookiesKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  'user-shard': 'user-shard',
  role: 'role',
};

export const transformString = (data: string) => {
  // Ensure input is valid (at least 7 characters long to apply transformation)
  if (data) {
    // Extract prefix, middle (XXXXX), and suffix
    const prefix = data.slice(0, 3); // Always '501'
    const suffix = data.slice(-4); // Last 4 characters from the input

    // Construct the desired format
    return `${prefix}XXXXX${suffix}`;
  }
  return '';
};

const validateKeys: string[] = Object.values(cookiesKeys);

export const setCookies = (key: string, values: any): void => {
  if (!validateKeys.includes(key)) {
    throw new Error(`Invalid key: ${key}`);
  }
  try {
    const stringValue = JSON.stringify(values);
    const encodedValue = btoa(stringValue);
    Cookies.set(key, encodedValue, {
      secure: true,
      sameSite: 'strict',
      path: '/', // Cookie only available for this domain
    });
  } catch (error) {
    console.error('Error setting cookie:', error);
    throw error;
  }
};

export const getCookies = (key: string): any => {
  if (!validateKeys.includes(key)) {
    throw new Error(`Invalid key: ${key}`);
  }
  try {
    const value = Cookies.get(key);
    if (!value) return null;

    const decodedValue = atob(value);
    return JSON.parse(decodedValue);
  } catch (error) {
    // console.error('Error getting cookie:', error);
    return null;
  }
};

export const removeCookies = (key: string): void => {
  if (!validateKeys.includes(key)) {
    throw new Error(`Invalid key: ${key}`);
  }
  Cookies.remove(key);
};
